module.exports = __webpack_public_path__ + "media/images/emblems/Tenero-Contra-coat_of_arms-e43a4d919129a323785990b0722abd2a.svg";